import { CircleInfoIcon } from "@xola/icons";
import { Tooltip } from "@xola/ui-kit";
import clsx from "clsx";
import { FormField } from "common";
import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { MessageTemplate } from "types";
import { formatTextWithLineBreaks } from "../../../helpers/validationHelper";
import { NoTranslate } from "../NoTranslate";
import { RichEditor } from "../RichEditor";
import { htmlToDisabledHtml } from "../RichEditor/RichEditor";
import { FormState } from "./MessageModalTypes";

interface SmsFormProps {
    template: MessageTemplate | null;
    editTemplate?: boolean;
}

const SmsForm = ({ template, editTemplate }: SmsFormProps) => {
    const { values, setFieldValue } = useFormikContext<FormState>();

    const [renderEditor, setRenderEditor] = useState<boolean>(false);

    useEffect(() => setRenderEditor(true), []);
    return (
        <div className="mt-4">
            <FormField label="Message" name="sms.body">
                {template?.sms?.body && !editTemplate ? (
                    <div
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: htmlToDisabledHtml(formatTextWithLineBreaks(template?.sms?.body) ?? ""),
                        }}
                        // TODO: See HtmlMessageTemplate try dompurify
                        className="no-translate rounded border border-gray-light bg-gray-lighter py-2.5 px-3 text-gray hover:border-black"
                    />
                ) : (
                    renderEditor && (
                        <RichEditor
                            isSmsEditor
                            height={200}
                            initialContent={template?.sms?.body ?? ""}
                            onChange={(html) => {
                                setFieldValue("sms.body", html);
                            }}
                        />
                    )
                )}

                <div className="flex justify-end text-sm">
                    <NoTranslate
                        as="div"
                        className={clsx("pr-1", values.sms.body.length > 160 ? "text-danger" : "text-gray")}
                    >
                        {values.sms.body.length}/160
                    </NoTranslate>
                    <Tooltip content="SMS messages that exceeded 160 characters will be sent as multiple texts. Maximum number of characters is 737">
                        <CircleInfoIcon />
                    </Tooltip>
                </div>
            </FormField>
        </div>
    );
};

export default SmsForm;
